<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 14152 14152"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0" d="M7076 0c-3908,0 -7076,3168 -7076,7076 0,3908 3168,7076 7076,7076 3908,0 7076,-3168 7076,-7076 0,-3908 -3168,-7076 -7076,-7076zm3057 11699l0 0c-839,0 -1519,-681 -1519,-1520 0,-839 680,-1520 1519,-1520 481,0 909,225 1188,573l-1294 708 439 501 872 -1186c197,256 315,576 315,924 0,839 -680,1520 -1520,1520zm1564 -5400l0 0c0,643 -522,1165 -1166,1165l-7159 0c-644,0 -1166,-522 -1166,-1165l0 -1998c0,-644 522,-1166 1166,-1166l7159 0c644,0 1166,522 1166,1166l0 1998z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'ElMeter',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1;fill-rule:nonzero}
</style>
